import React from 'react';
import { IconProps } from './types';
import classes from './styledIcons.module.css';
import clsx from 'clsx';

export const EditDocumentIcon = (props: IconProps & { isInsideVerticalStepper?: boolean , isHorizontalForHoelt?: boolean }) => {
    const wrapperContainerClass = props.currentActive ? classes.iconBorderActive : classes.iconBorderInactive;
    const wrapperClass = props.isDone ? classes.active : classes.inactive;
    const iconBGFillClass = props.isDone ? classes.iconBGActive : classes.iconBGInactive;
    const getIconStatus = () => (props.isDone ? classes.iconColorActive : classes.iconColorInactive);

    const iconFillClass = props.isInsideVerticalStepper
        ? classes['vertical-stepper-icon-color-active']
        : getIconStatus();

    return (
        <div
            className={clsx(
                props.isInsideVerticalStepper ? classes['wrapper-inside-vertical-stepper'] : classes.wrapperContainer,
                 wrapperContainerClass,
            )}
        >
            <div
                className={clsx(
                     ( props.isHorizontalForHoelt) ? classes['icon-wrapper-horizontal-for-hoelt'] : classes.wrapper,
                    props.isInsideVerticalStepper ? classes['icon-wrapper-inside-vertical-stepper'] : wrapperClass,
                )}
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="none">
                    <mask
                        id="mask0_10709_4932"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                    >
                        <rect width="24" height="24" fill="#D9D9D9" className={iconBGFillClass} />
                    </mask>
                    <g mask="url(#mask0_10709_4932)">
                        <path
                            d="M14 22V18.925L20.575 12.375L23.65 15.425L17.075 22H14ZM15.5 20.5H16.45L19.475 17.45L19.025 16.975L18.55 16.525L15.5 19.55V20.5ZM4 22V2H14L20 8V11H18V9H13V4H6V20H12V22H4ZM19.025 16.975L18.55 16.525L19.475 17.45L19.025 16.975Z"
                            fill="white"
                            className={iconFillClass}
                        />
                    </g>
                </svg>
            </div>
        </div>
    );
};
